// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control{
  box-shadow: none;
}

.btn{
  box-shadow: none;
}

textarea {
  resize: none;
  height: 300px;
  width:800px;
}

button:focus, button:active:focus, button.active:focus {
  outline: none !important;
  outline-style: none !important;
  }


`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/prijavi-napako/prijavi-napako.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B","sourcesContent":[".form-control{\n  box-shadow: none;\n}\n\n.btn{\n  box-shadow: none;\n}\n\ntextarea {\n  resize: none;\n  height: 300px;\n  width:800px;\n}\n\nbutton:focus, button:active:focus, button.active:focus {\n  outline: none !important;\n  outline-style: none !important;\n  }\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
